// extracted by mini-css-extract-plugin
export var button = "galleryCard-module--button--beab1";
export var cardLink = "galleryCard-module--cardLink--90370";
export var dark = "galleryCard-module--dark--e8910";
export var galleryCard = "galleryCard-module--galleryCard--a7362";
export var hoverContainer = "galleryCard-module--hoverContainer--256c9";
export var imageContainer = "galleryCard-module--imageContainer--5ee90";
export var imageWrapper = "galleryCard-module--imageWrapper--7edaa";
export var light = "galleryCard-module--light--c730e";
export var svgWrapper = "galleryCard-module--svgWrapper--c3874";
export var title = "galleryCard-module--title--f35ad";